module.exports = __webpack_public_path__ + "assets/img/conversion_coin.0b608b68.png";